import APIRequest from './api_request';

const handleResponse = (error, response, resolve, reject) => {
  if (response && response.body && response.body.errors) {
    return reject(response.body.errors);
  }

  if (error) {
    return reject(error);
  }

  return resolve(response.body);
};

export const promisifiedGet = (resource) => new Promise((resolve, reject) => {
  APIRequest.get({ resource }).end((error, response) => {
    handleResponse(error, response, resolve, reject);
  });
});

export const promisifiedPost = (resource, data) => new Promise((resolve, reject) => {
  APIRequest.post({ resource, data }).end((error, response) => {
    handleResponse(error, response, resolve, reject);
  });
});

export const promisifiedPatch = (resource, data) => new Promise((resolve, reject) => {
  APIRequest.patch({ resource, data }).end((error, response) => {
    handleResponse(error, response, resolve, reject);
  });
});

export const promisifiedDelete = (resource) => new Promise((resolve, reject) => {
  APIRequest.delete({ resource }).end((error, response) => {
    handleResponse(error, response, resolve, reject);
  });
});
